import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import classNames from 'classnames';
import { getCanShareNode } from 'utils';
import { AVAILABILITY_STATE } from 'router/subrouters/DataRoom/models/DataRoomBulk';
import {
  getIsChecked,
  getIsMixed,
  getNodeCurrentState,
} from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/DataRoomDocumentDrawers/ManageFileAccess/utils';

const useNodeVariables = ({
  node,
  checkedFilesIds,
  checkIfNodeIsDisabled,
}: {
  node: DataRoomNode;
  checkedFilesIds: string[];
  checkIfNodeIsDisabled?: (node: DataRoomNode) => boolean;
}) => {
  const { enabledState } = node;

  const canShareNode = getCanShareNode(node);

  const currState = getNodeCurrentState(node, checkedFilesIds || []);
  const checked = getIsChecked(currState);
  const mixed = getIsMixed(currState);

  const disabled =
    !canShareNode ||
    enabledState === AVAILABILITY_STATE.OFF ||
    checkIfNodeIsDisabled?.(node);

  const nodeClass = classNames({
    disabled,
    mixed,
  });

  return { checked, disabled, nodeClass, currState };
};

export default useNodeVariables;
